$(function(){
  var $header = $(".header"),
      $intro = $header.find(".intro"),
      $link = $intro.find("li a"),
      $arrowDown1 = $header.find(".arrow-down1"),
      $detailBlock = $("#detail-block"),
      $arrowDown2 = $detailBlock.find(".arrow-down2"),
      $about = $('.aboutUs').find('a');

  /**
   * @param {[Number]} {type}
   */
  function bindClick(element, type){
      var $element = typeof element == "string" ? $(element) : element;
      $element.on("click", function(e){
          var $this = $(this),
              $target = $($this.attr("href")),
              windowHeight = $(window).height(),
              targetHeight = $target.height(),
              scrollTop = $target.offset().top,
              distanceTop = windowHeight * 0.25,
              toTop;
          switch(type){
              case 1:
                  toTop = scrollTop - (windowHeight / 2 - targetHeight / 2) + distanceTop;
                  break;
              case 2:
                  toTop = scrollTop;
                  break;
          }
          e.preventDefault();
          $("html, body").animate({scrollTop: toTop}, 200);
      });
  }

  /**
   * 
   * @param element
   */
  function payClick(){
      var payBtn = $('.pay-btn');
      var payImg = $('.payImg');
      payBtn.on('click',function (e) {
          payImg.toggle(500)
      })
  }

  /**
   * 
   */
  function resumeClick(){
      var resumeSpans = $('.top-block li span');
      var resumeImg = $('.top-block .resumeImg');
      var resume=$('.aboutUs .resume');
      var img = $('.aboutUs .resumeImg');
      resumeSpans.each(function (index,ele) {
          $(ele).on('click',function (e) {
            resumeImg.show()
          })
      })
      resume.on('click',function (e) {
          img.toggle(500)
      })
  }

  function productClick(){
      var pTags = $('.middle-wrap .first p');
      var resumeImg = $('.middle-wrap .first img');
      pTags.each(function (index,ele) {
          $(ele).on('click',function (e) {
              resumeImg.toggle(500)
          })

      })
  }

  bindClick($link, 1);
  bindClick($arrowDown1, 2);
  bindClick($arrowDown2, 2);
  bindClick($about, 1);
  payClick();
  resumeClick();
  productClick()
});